// extracted by mini-css-extract-plugin
export default {"add":"Add_add__bf7Ch","active":"Add_active__pK9me"};